<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "bold";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      d="M13.3636 17.3636C13.0121 17.7151 13.0121 18.2849 13.3636 18.6364C13.7151 18.9878 14.2849 18.9878 14.6364 18.6364L20.6364 12.6364C20.9878 12.2849 20.9878 11.7151 20.6364 11.3636L14.6364 5.36358C14.2849 5.01211 13.7151 5.01211 13.3636 5.36358C13.0121 5.71505 13.0121 6.2849 13.3636 6.63637L17.8272 11.1L3.99998 11.1C3.50292 11.1 3.09998 11.5029 3.09998 12C3.09998 12.497 3.50292 12.9 3.99998 12.9L17.8272 12.9L13.3636 17.3636Z"
    />
    <path
      v-else-if="weight === 'bold'"
      d="M12.9393 16.9393C12.3536 17.5251 12.3536 18.4749 12.9393 19.0607C13.5251 19.6464 14.4749 19.6464 15.0607 19.0607L21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L15.0607 4.93934C14.4749 4.35355 13.5251 4.35355 12.9393 4.93934C12.3536 5.52513 12.3536 6.47487 12.9393 7.06066L16.3787 10.5L4 10.5C3.17157 10.5 2.5 11.1716 2.5 12C2.5 12.8284 3.17157 13.5 4 13.5H16.3787L12.9393 16.9393Z"
    />
  </svg>
</template>
